import React from 'react';
import FirstApartament from './Components/FirstApartament';
import SecondApartament from './Components/SecondApartament';
import ThirdApartament from './Components/ThirdApartament';
import FourthApartament from './Components/FourthApartament';
import FifthApartament from './Components/FifthApartament';
import SixthApartament from './Components/SixthApartament';

function Floor10() {

  return (
    <div className="relative w-full mt-40 mb-40 lg:h-auto">
      <div className="w-[100vw] relative flex center top-[50vw] lg:top-0">
        <img
          className='w-[100vw]'
          src="/images/click/clickable-images/Floors/Direct-floors/clean-floors/Floor10K5K6.jpg"
          alt=""
        />
        <>
          <FirstApartament />
          <SecondApartament />
          <ThirdApartament />
          <FourthApartament />
          <FifthApartament />
          <SixthApartament />
        </>
      </div>
    </div>
  );
}

export default Floor10;
